import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useMediaQuery } from '../../hooks';
import styles from './index.module.scss';

const Navbar = () => {
  const router = useRouter();
  const screenSize = useMediaQuery();
  const [isSignupPanelVisible, setIsSignupPanelVisible] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const signupPanel = document.getElementById('signup');
    if (!signupPanel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSignupPanelVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of the panel is visible
        rootMargin: '0px 0px -50px 0px', // Add some margin to trigger before fully out of view
      }
    );

    observer.observe(signupPanel);

    return () => {
      observer.disconnect();
    };
  }, [router.pathname]);

  const handleClick = useCallback(
    (e) => {
      if (router.pathname === '/island') {
        e.preventDefault();
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(() => {
            const emailInput = document.getElementById(
              'newsletter-email-signup'
            );
            if (emailInput) {
              emailInput.focus();
            }
          }, 500);
        }
        return;
      }
      e.preventDefault();
      router.push('/island').then(() => {
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Focus on email input after navigation and scrolling
            setTimeout(() => {
              const emailInput = document.getElementById(
                'newsletter-email-signup'
              );
              if (emailInput) {
                emailInput.focus();
              }
            }, 500);
          }, 50);
        }
      });
    },
    [router]
  );

  return (
    <div className={styles.navbar} role="banner">
      <a
        href="/island"
        className={styles.logoWrapper}
        aria-label="BF Island Home"
      >
        <img
          className={styles.logo}
          src="/static/images/logo.png"
          alt="Island logo"
        />
      </a>
      {!screenSize.isMobile && !isSignupPanelVisible && (
        <button
          href="/island"
          className={styles.button}
          aria-label="Scroll to top of island page"
          onClick={handleClick}
        >
          <div className={styles.buttonText}>Join the Waitlist</div>
        </button>
      )}
    </div>
  );
};

export default Navbar;
